import { render, staticRenderFns } from "./OrderLocation.vue?vue&type=template&id=1899da14&scoped=true"
import script from "./OrderLocation.vue?vue&type=script&lang=js"
export * from "./OrderLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1899da14",
  null
  
)

export default component.exports